import { render } from "./PhoneField.vue?vue&type=template&id=089c99ce&scoped=true&ts=true"
import script from "./PhoneField.vue?vue&type=script&lang=ts"
export * from "./PhoneField.vue?vue&type=script&lang=ts"

import "./PhoneField.vue?vue&type=style&index=0&id=089c99ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089c99ce"]])

export default __exports__